import ConsultaInteligente from './ConsultaInteligente';

export default ConsultaInteligente;